import React, { Dispatch, ReactElement } from "react";

import Nav from "react-bootstrap/Nav";

import styles from "./sidebar.module.scss"
import { Accordion } from "react-bootstrap";
import SidebarNavCard from "./SidebarNavCard";
import SidebarMenuItem from "../models/SidebarMenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarShow, SidebarAction, SidebarActionTypes } from "infrastructure/store/sidebar/SidebarActions";
import IAppState from "infrastructure/store/IAppState";
import SidebarState from "infrastructure/store/sidebar/SidebarState";

interface IProps {
  items: Array<SidebarMenuItem>;
  activeCardId: string;
}

const SideBar: React.FC<IProps> = (props) => {
  // store
  const sidebarDispatch = useDispatch<Dispatch<SidebarAction>>();
  const sidebarShow = useSelector<IAppState, SidebarState>((store) => store.sidebar).sidebarShow;

  // handlers
  const toggleSidebarHandler = () => {
    sidebarDispatch(setSidebarShow(!sidebarShow));

    // remove disabling page scroll on mobile devices
    // 768px = default bootstrap md breakpoint
    if (!window.matchMedia("(min-width: 768px)").matches) {
      document.body.classList.remove("overflow-hidden");
    }
  }

  // sub-renders
  const renderMenuCards = (items: Array<SidebarMenuItem>): Array<ReactElement> => {
    return items.map((item) => 
      <SidebarNavCard menuItem={item} activeCardId={props.activeCardId} key={item.id} />
    );
  };

  // helpers
  const sidebarClasses = (show: boolean) => {
    return show ? `${styles.sidebar}` : `${styles.sidebarActive} ${styles.sidebarClose} ${styles.sidebar}`;
  }

  // render
  return (
    <Nav className={sidebarClasses(sidebarShow)}>
      <button type="button" className={`d-md-none btn ${styles.sidebarCloseBtn}`} onClick={toggleSidebarHandler}>
        <FontAwesomeIcon icon="times" />
      </button>
      <Accordion className={`px-3 pt-2 p-md-0 ${styles.sidebarAccordion}`} defaultActiveKey={props.activeCardId}>
        {renderMenuCards(props.items)}
      </Accordion>
    </Nav>
  );
};

export default SideBar;